import { ListItem } from "@mui/material";
import { Button, ListGroup, Modal } from "react-bootstrap";

const SuppliesOrderModal = ({
    selectedSuppliesOrder,
    setSelectedSuppliesOrder
}) => {
    const closeModal = () => {
        setSelectedSuppliesOrder(null);
    };

    return (
        <Modal show={selectedSuppliesOrder !== null} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Order details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="m-2">
                    <strong>UPDATED AT</strong>: {new Date(selectedSuppliesOrder.updatedAt).toLocaleString()}
                </div>
                <div className="m-2">
                    <strong>STATUS</strong>: {selectedSuppliesOrder.status}
                </div>
                <div className="m-2">
                    <strong>ADDRESS</strong>:
                    <ListGroup >
                        <ListItem><span className="text-muted">Street</span>: {selectedSuppliesOrder.street}</ListItem>
                        <ListItem><span className="text-muted">City</span>: {selectedSuppliesOrder.city}</ListItem>
                        <ListItem><span className="text-muted">State</span>: {selectedSuppliesOrder.state}</ListItem>
                        <ListItem><span className="text-muted">Zip</span>: {selectedSuppliesOrder.zipCode}</ListItem>
                    </ListGroup>
                </div>
                <div className="m-2">
                    <strong>SUPPLIES</strong>:
                    <ListGroup>
                        {selectedSuppliesOrder.supplies.map(row => (
                            <ListItem key={row.id}>
                                <span className="text-muted">{row.supply.name}</span>: {row.quantity}
                            </ListItem>
                        ))}
                    </ListGroup>
                </div>
                {selectedSuppliesOrder.specialRequest &&
                    <div className="m-2">
                        <strong>SPECIAL REQUEST</strong>:
                        <ListGroup>
                            <ListItem>{selectedSuppliesOrder.specialRequest}</ListItem>
                        </ListGroup>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SuppliesOrderModal;
